import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-3 py-1 rounded font-bold">
                FDP
              </div>
              <span className="font-bold text-lg">Kai Alexander Bewig</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Kandidat für den Stadtrat Lauingen (Donau) - Für eine moderne, vernetzte und bürgernähe Stadtpolitik.
            </p>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4">Kontakt</h3>
            <div className="space-y-2 text-gray-400">
              <p>Schimmelstraße 6</p>
              <p>89415 Lauingen</p>
              <a href="mailto:kai@bewig.de" className="text-blue-400 hover:text-blue-300 transition-colors">
                kai@bewig.de
              </a>
              <br />
              <a href="tel:09072-718110" className="text-blue-400 hover:text-blue-300 transition-colors">
                09072-718110
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4">Rechtliches & Links</h3>
            <div className="space-y-2">
              <Link to="/kontakt" className="block text-gray-400 hover:text-white transition-colors">
                Kontakt
              </Link>
              <Link to="/impressum" className="block text-gray-400 hover:text-white transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="block text-gray-400 hover:text-white transition-colors">
                Datenschutz
              </Link>
              <div className="pt-4">
                <div className="bg-yellow-400 text-blue-900 px-4 py-2 rounded-full inline-block font-bold">
                  Deine Wahl. 8.3.26
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Kai Alexander Bewig - Freie Demokraten (FDP)
            </p>
            <div className="mt-4 md:mt-0 bg-pink-600 text-white px-4 py-2 rounded font-bold">
              Bürgernähe durch Vernetzung
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;